

export const environment = {
	production: true,
	apiUrl:'https://api-b2b.demo.revest.sa',
	rsa_public_key: "$2a$10$e.oPc.dyrwRoQCpDvO9Rhe",
	customerUrl: 'https://b2b-customer.demo.revest.sa',
	recaptchaSiteKey: '6Le2ZDMsAAAAAKSWjZWr2MqUhUhkbw6l6BDOI8JA',
  	enableCaptcha: true
};
